import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Update all statuses',
      title: 'Update all order statuses',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'All order statuses successfully updated',
    }
  }
}